export const resultsRowTemplate = `
<div class="o__search__instant-search__post {{#is_external}}o__search__instant-search__post--external{{/is_external}}">
  <article class="m__blog-post-row" itemtype="http://schema.org/Article">
  
    <span class="m__blog-post-row__col m__blog-post-row__col1">
        {{{post_date_formatted}}}
    </span>
  
    <span class="m__blog-post-row__col m__blog-post-row__col2">
      <a
      href="{{link}}"
      title="{{post_title}}"
      {{#is_external}}
      target="_blank"
      {{/is_external}}
      class="entry-title-link">
        {{{post_title}}}
        ${window.icons_html.external}
      </a>
      <span class="excerpt">... {{{_snippetResult.post_content.value}}} ...</span>
    </span>
  
     <span class="m__blog-post-row__col m__blog-post-row__col3">
     
      {{#is_external}}
      
        {{#external_author_name}}
           <a href="{{link}}">
            {{{external_author_name}}}
           </a>
       {{/external_author_name}}
       
       {{^external_author_name}}
           <a href="{{link}}">
            {{{post_author.display_name}}}
           </a>
       {{/external_author_name}}
       
      {{/is_external}}
      
      {{^is_external}}
       <a href="{{post_author.user_url}}">
        {{{post_author.display_name}}}
       </a>
      {{/is_external}}
      
    </span>
    
    <!--<span class="m__blog-post-row__col m__blog-post-row__col4">
        {{{tax_idea}}}
    </span>-->
    
    <!--<span class="m__blog-post-row__col m__blog-post-row__col5">
        {{{tax_thesis}}}
    </span>-->

    <a class="admin-only edit-link" style="display:none" href="{{edit_link}}">edit</a>
  
  </article>
  
  <article class="m__blog-post-row--mobile" itemtype="http://schema.org/Article">
  
    <span class="m__blog-post-row__col m__blog-post-row__col1">
       {{{post_date_formatted}}}
    </span>
    
    <span class="m__blog-post-row__col m__blog-post-row__col1 m__blog-post-row__col1--mobile">
        {{{post_date_formatted_abbr}}}
    </span>
  
  <article class="m__blog-post-row__col m__blog-post-row__col2">
  
    <div class="m__blog-post-row__col2__row1">
      <a
      href="{{link}}"
      title="{{post_title}}"
      {{#is_external}}
      target="_blank"
      {{/is_external}}
      class="entry-title-link">
        {{{post_title}}}
        ${window.icons_html.external}
      </a>
    </div>
    
    <div class="m__blog-post-row__col2__row2">
      <a href="{{ post_author.user_url }}">
        {{{post_author.display_name}}}
      </a>
    </div>
  
  </article>
  
  </article>

</div>`
